// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__YtdC_","large":"styles_large__1NWvG"};